import React from 'react';
import { Button } from '../ui/Button';
import { FadeIn } from '../ui/FadeIn';
import { Sun, Moon } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-24 pb-20 md:pt-32 md:pb-28 px-6 overflow-hidden" data-id="element-45">
      <div className="max-w-4xl mx-auto text-center" data-id="element-46">
        <FadeIn delay={0.1} data-id="element-47">
          <div className="flex items-center justify-center gap-4 mb-8 text-[#C26D5C]" data-id="element-48">
            <Sun className="w-5 h-5" strokeWidth={1.5} data-id="element-49" />
            <span className="h-px w-12 bg-current opacity-30" data-id="element-50"></span>
            <Moon className="w-5 h-5" strokeWidth={1.5} data-id="element-51" />
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-52">
          <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl leading-[1.1] tracking-tight mb-6 text-[#1C1917]" data-id="element-53">
            El Ritual de 10 Minutos que Cambia tu Día
          </h1>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-54">
          <p className="text-lg md:text-xl text-[#4A4541] max-w-2xl mx-auto mb-10 leading-relaxed font-light" data-id="element-55">
            Toma el control de tu sistema nervioso y elimina la ansiedad
            matutina sin meditaciones largas de 30 minutos.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-56">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-57">
            <Button href="#comprar" size="lg" className="w-full sm:w-auto" data-id="element-58">
              Quiero El Ritual Ahora
            </Button>
            <div className="flex flex-col items-center sm:items-start text-sm text-[#736B65]" data-id="element-59">
              <span className="font-medium text-[#1C1917]" data-id="element-60">
                Precio de Validación: $6.39 USD
              </span>
              <span data-id="element-61">Acceso inmediato</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}